import {makeStyles} from '@material-ui/core';
import {getDirectionStyles} from '../../../../../../utils/ThemeUtils';

import {TOOLTIP_WIDTH} from './ActivationsItem';

const useStyles = makeStyles(theme => ({
    activationTooltip: {
        background: theme.palette.background.paper,
        position: 'absolute',
        padding: '14px 17px 22px',
        width: '100%',
        minWidth: `${TOOLTIP_WIDTH}px`,
        boxShadow: '0px 5px 10px rgba(0, 0, 0, 0.35)',
        borderRadius: 4,
        opacity: 0,
        pointerEvents: 'none',
        zIndex: 1,
        left: 0,
        top: 0,

        [theme.breakpoints.up(1025)]: {
            position: 'fixed'
        },

        [theme.breakpoints.up('fxs')]: {
            width: `${TOOLTIP_WIDTH}px`
        }
    },
    activationTooltipDate: {
        color: theme.palette.text.secondary,
        padding: getDirectionStyles(theme.direction)(
            theme.spacing(0, 22, 0, 0),
            theme.spacing(0, 0, 0, 22)
        )
    },
    activationTooltipNumbers: {
        position: 'absolute',
        top: 10,
        left: getDirectionStyles(theme.direction)('unset', 20),
        right: getDirectionStyles(theme.direction)(20, 'unset'),
        display: 'flex',
        color: theme.palette.text.primary,

        '& .trend-container': {
            margin: getDirectionStyles(theme.direction)(
                theme.spacing(0, 0, 0, 2),
                theme.spacing(0, 2, 0, 0)
            ),

            '& > span': {
                fontSize: theme.typography.pxToRem(11)
            }
        }
    },
    activationTooltipText: {
        position: 'relative',
        padding: getDirectionStyles(theme.direction)(
            theme.spacing(0, 0, 0, 3),
            theme.spacing(0, 3, 0, 0)
        ),
        marginTop: theme.spacing(2)
    },
    activationTooltipColorDot: {
        position: 'absolute',
        top: 5,
        left: getDirectionStyles(theme.direction)(0, 'unset'),
        right: getDirectionStyles(theme.direction)('unset', 0)
    },
    activationTooltipAccolade: {
        fontWeight: 'bold',
        letterSpacing: 0.4,
        color: theme.palette.text.primary
    },
    activationTooltipDescription: {
        color: theme.palette.text.secondary,
        fontSize: theme.typography.pxToRem(12),
        lineHeight: theme.typography.pxToRem(15),
        marginTop: 2
    },
    activationTooltipAnimation: {
        opacity: 1
    }
}));

export default useStyles;
